import { Component, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { ActivatedRoute, RouterLink } from "@angular/router";

@Component({
    selector: "app-error-page",
    templateUrl: "./error-page.component.html",
    styleUrls: ["./error-page.component.css"],
    imports: [MatButtonModule, RouterLink]
})
export class ErrorPageComponent implements OnInit {
  errorMessage =
    "O sistema está temporariamente indisponível, por favor tente mais tarde, ou tente logar novamente.";
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.getErrorType();
  }
  getErrorType() {
    const type = this.route.snapshot.queryParamMap.get("type");
    if (type === "permission")
      this.errorMessage = "Não foi possível se autenticar ao sistema. Entre em contato com o Administrador para confirmar se que possui acesso ao sistema e tente novamente.";
  }
}
